export const changePassword = (values) => {
  return {
    newPassword: values.newPassword,
    confirmNewPassword: values.confirmNewPassword,
  };
};
